export default {
	nav: {
		features: "Recursos",
		screens: "Pantallas",
		plans: "Planes",
		faq: "Preguntas",
		contact: "Contacto",
		login: "Entrar",
		tryFree: "Probar gratis",
		lightMode: "Modo claro",
		darkMode: "Modo oscuro",
	},
	hero: {
		eyebrow: "Gestión para templos de Umbanda",
		titleLine1: "Cuida del axé.",
		titleLine2: "El ORI cuida de la gestión.",
		lead: "Consultantes, corriente mediúmnica, rituales, fichas, finanzas y comunicación — todo en un solo lugar, con respeto por las tradiciones y la sencillez que tu templo merece.",
		ctaPrimary: "Comenzar prueba gratis",
		ctaSecondary: "Ver el sistema por dentro",
		trust: "30 días gratis · no pedimos tarjeta para empezar",
		memberQuestion: "¿Recibiste una invitación de tu templo?",
		memberLink: "Entrar como miembro",
		shotAlt: "Panel del ORI",
	},
	features: {
		eyebrow: "Recursos",
		title: "Todo lo que tu templo necesita",
		subtitle: "Un sistema pensado para el día a día del templo — desde el registro del consultante hasta el llamado de fichas en la televisión del salón.",
		more: "Y además: panel e informes · fotos en los perfiles · retornos y seguimiento · disponible en 4 idiomas.",
		note: "Los pagos y las alertas por WhatsApp son adicionales opcionales. Las tarifas de cada transacción en Mercado Pago las cobra la propia plataforma, no el ORI.",
		people: {
			title: "Personas y corriente",
			text: "Consultantes, médiums y miembros con registro completo, fotos e historial de asistencia.",
		},
		journey: {
			title: "Trayectoria del médium",
			text: "Acompaña la evolución mediúmnica: guías espirituales, orixás e hitos de desarrollo.",
		},
		rituals: {
			title: "Rituales y giras",
			text: "Agenda de rituales, tipos de ritual y control de asistencia de la corriente.",
		},
		agenda: {
			title: "Agenda pública y reservas",
			text: "Publica tus rituales en un enlace único y recibe reservas de asistencia de los consultantes — con aprobación y control de cupos.",
		},
		tickets: {
			title: "Fichas y atención",
			text: "Distribuye fichas por guía espiritual y médium, e imprímelas en impresora térmica por menos de un centavo.",
		},
		tv: {
			title: "ORI TV — llamado en la TV",
			text: "El llamado de fichas en la televisión del salón, en tiempo real y con aviso sonoro.",
		},
		financial: {
			title: "Finanzas",
			text: "Fondos, contribuciones, mensualidades e informes: las cuentas del templo bajo control.",
		},
		payments: {
			title: "Pagos por PIX",
			text: "Cobra mensualidades y contribuciones por PIX o tarjeta, con conciliación automática y débito recurrente.",
		},
		whatsapp: {
			title: "Avisos por WhatsApp",
			text: "Cobros, confirmaciones y recordatorios también por WhatsApp, con el consentimiento de cada persona.",
		},
		assistant: {
			title: "Asistente con IA",
			text: "Un asistente dentro del sistema que resuelve dudas y ayuda a configurar el templo paso a paso.",
		},
	},
	screens: {
		eyebrow: "Por dentro",
		title: "Las pantallas que usarás todos los días",
		subtitle: "Sin rodeos: así es como el ORI se ve de verdad.",
		prev: "Anterior",
		next: "Siguiente",
		dashboard: {
			title: "Panel general",
			desc: "El templo de un vistazo: métricas, cumpleañeros, próximos rituales y gráficos.",
		},
		consulentes: {
			title: "Consultantes",
			desc: "Búsqueda, filtros e historial de atenciones de cada consultante.",
		},
		corrente: {
			title: "Corriente mediúmnica",
			desc: "Médiums con su trayectoria espiritual, orixás y funciones en el templo.",
		},
		rituais: {
			title: "Rituales",
			desc: "Detalles del ritual: estado, tipo, fichas y estadísticas.",
		},
		agenda: {
			title: "Agenda pública",
			desc: "Un enlace para que el consultante vea los próximos rituales y reserve su lugar, sin iniciar sesión.",
		},
		financeiro: {
			title: "Finanzas",
			desc: "Fondos, metas, flujo de caja y gráficos en un solo panel.",
		},
		pagamentos: {
			title: "Pagos por PIX",
			desc: "Cobro por Mercado Pago con conciliación automática y débito recurrente.",
		},
		assistente: {
			title: "Asistente ORI",
			desc: "La IA que resuelve dudas y ayuda a configurar el templo paso a paso.",
		},
		atendimento: {
			title: "Distribución de fichas",
			desc: "Fichas organizadas por guía espiritual y médium responsable.",
		},
		oritv: {
			title: "ORI TV",
			desc: "Llamado de fichas en la televisión del salón — el consultante sigue su turno.",
		},
		ticket: {
			title: "Ficha impresa",
			desc: "Código, guía espiritual, médium y horario impresos por menos de un centavo.",
		},
	},
	testimonials: {
		eyebrow: "Quién lo usa",
		title: "Templos que respiran más tranquilos",
		more: "leer más…",
		less: "mostrar menos",
		prev: "Anterior",
		next: "Siguiente",
		jean: {
			p1: "Antes de usar el ORI, gran parte de nuestro tiempo se consumía en procesos administrativos manuales, como la gestión de rituales, atenciones, control financiero y muchas otras tareas del día a día del templo.",
			p2: "Con el ORI, toda esa gestión se volvió mucho más sencilla, organizada y eficiente. Hoy logramos administrar todo con mucha más agilidad, seguridad y practicidad.",
			p3: "El mayor beneficio es que dejamos de perder tiempo con burocracias y podemos dedicar nuestra energía a lo que de verdad importa: la caridad, la acogida y la atención espiritual a las personas.",
			p4: "Felicito a todo el equipo por el excelente trabajo. Recomiendo el ORI a todos los templos que deseen modernizar su gestión sin perder el fundamento y la esencia de la religión.",
		},
		priscilla: {
			p1: "El ORI llegó como una excelente herramienta para nuestro templo en cuanto al control de asistentes y su historial.",
			p2: "Nuestro templo tiene como norma distribuir las atenciones dirigiéndolas a entidades específicas, y el ORI me ayuda con el historial, e incluso con el pedido de las entidades para que el consultante regrese.",
			p3: "Además, cuenta con el registro de todos los médiums del templo, alertas para los cumpleañeros, alertas financieras para el pago de las mensualidades y control de caja, donde logramos tener en una sola herramienta la visión de toda nuestra organización.",
			p4: "Para mí, el ORI vino a facilitar y organizar nuestros datos. Como organización religiosa no tenemos a alguien dedicado solo a esto, así que nuestros administradores alimentan el sistema y me facilita las cosas cuando necesito reunir datos precisos en un solo lugar.",
			p5: "Lo recomiendo muchísimo a los líderes espirituales que, como yo, tienen una vida profesional agitada, pero no renuncian a mantener siempre en orden nuestra casa espiritual.",
		},
	},
	plans: {
		eyebrow: "Planes",
		title: "Un plan que se ajusta a tu templo",
		subtitle: "Una base ORI más los adicionales que quieras. Los 30 días gratis valen para el plan base — sin compromiso y sin tarjeta.",
		fallback: "No pudimos cargar los planes en este momento.",
		fallbackCta: "Probar 30 días gratis",
	},
	faq: {
		eyebrow: "Preguntas",
		title: "Preguntas frecuentes",
		trial: {
			q: "¿Puedo probar el ORI?",
			a: "Sí. Son 30 días gratis en el plan base, sin tarjeta de crédito. Los adicionales — pagos por Mercado Pago y alertas por WhatsApp — no entran en la prueba.",
		},
		security: {
			q: "¿Mis datos están seguros?",
			a: "Por completo. Usamos cifrado, aislamiento por templo y copias de seguridad automáticas. Ningún templo accede a los datos de otro.",
		},
		mobile: {
			q: "¿Funciona en el celular y en la tablet?",
			a: "En tablets, el sistema funciona perfectamente. La versión para celular está en evolución.",
		},
		tv: {
			q: "¿Puedo llamar las fichas en la TV?",
			a: "Sí. El ORI tiene una aplicación para Google TV o Fire TV que llama las fichas en tiempo real, además de mostrar mensajes y videos personalizados a los consultantes.",
		},
		tickets: {
			q: "¿Puedo usar mis fichas físicas?",
			a: "Puedes usar tus fichas físicas o imprimirlas en impresora térmica por menos de un centavo por ficha — con código, guía espiritual, médium y horario, e incluso mensajes personalizados.",
		},
		multiTemple: {
			q: "¿Puedo usarlo en más de un templo?",
			a: "Sí. Una misma cuenta puede estar vinculada a varios templos con roles diferentes, y cada templo tiene su propio plan y suscripción.",
		},
		payments: {
			q: "¿El ORI recibe pagos?",
			a: "Sí, por Mercado Pago. La integración es un adicional opcional del plan: conectas la cuenta del templo y cobras mensualidades y contribuciones por PIX o tarjeta, con conciliación automática y débito recurrente. Las tarifas de cada transacción las cobra el propio Mercado Pago, y el dinero llega directo a la cuenta del templo.",
		},
	},
	cta: {
		eyebrow: "Empieza hoy",
		title: "¿Listo para organizar tu templo?",
		text: "Prueba el ORI por 30 días, sin compromiso y sin tarjeta. Toma pocos minutos empezar.",
		primary: "Crear mi templo",
		secondary: "Hablar con nosotros",
	},
	footer: {
		tagline: "Construido de un hijo del Axé para otro hijo del Axé.",
		invite: "Tengo una invitación",
		manual: "Manual",
		terms: "Términos de Uso",
		privacy: "Política de Privacidad",
		cause: "Apoyamos la causa autista",
		causeAlt: "Lazo del Autismo",
	},
};
